// availablePremiumAccessAgreements is only ever populated when the
// multi-PA experience is on, so its presence — even as an empty or
// single-entry list — is what signals the experience is active.
export const getIsMultiPaBulkDownloadActive = (
  availablePremiumAccessAgreements: unknown[] | undefined
): boolean => availablePremiumAccessAgreements !== undefined;
